import { render, staticRenderFns } from "./customer-care-modal.component.vue?vue&type=template&id=99ff810e&scoped=true"
import script from "./customer-care-modal.component.vue?vue&type=script&lang=js"
export * from "./customer-care-modal.component.vue?vue&type=script&lang=js"
import style0 from "./customer-care-modal.component.vue?vue&type=style&index=0&id=99ff810e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ff810e",
  null
  
)

export default component.exports